import React, { Component } from 'react'
import { Map, List, fromJS } from 'immutable'
import { Checkbox } from 'semantic-ui-react'

export default function CheckboxesInput({ value, name, id, onChange, onBlur, disabled, options = [] }) {
  if (Array.isArray(value)) value = fromJS(value)

  if (!List.isList(value)) value = List()

  return (
    <div className="form-field-checkboxes">
      {options.map(({ value: optionValue, label, icon }) => {
        let checked = value.indexOf(optionValue) > -1
        return (
          <Checkbox
            name={name}
            checked={checked}
            disabled={disabled}
            icon={icon}
            onChange={e =>
              onChange({ name, value: checked ? value.remove(value.indexOf(optionValue)) : value.push(optionValue) })
            }
            label={label}
            key={optionValue}
          />
        )
      })}
    </div>
  )
}
